import CountUp from 'countup';

const options = {
    useEasing: false,
    useGrouping: false,
    separator: ',',
    decimal: '.',
};

const timingConfig = {
    orders: {
        selector: '.js--stats-1',
        timing: [0, 95, 1, 1.9],
    },
    shipped: {
        selector: '.js--stats-2',
        timing: [0, 99.6, 1, 2.2],
    },
    callWait: {
        selector: '.js--stats-3',
        timing: [0, 8, 0, 1],
    },
    fulfilled: {
        selector: '.js--stats-4',
        timing: [0, 34, 0, 1.4],
    },
};

function initCount() {
    let count = 1;

    Array.from(document.getElementsByClassName('js--stats')).forEach((el) => {
        el.closest('.stats__stat')
            .getElementsByClassName('stats__bar__progress')[0]
            .classList.add('stats__bar--active');

        return count + 1 > 4 ? (count = 1) : (count += 1);
    });

    Object.values(timingConfig).forEach(({ selector, timing }) => {
        Array.from(document.querySelectorAll(selector)).forEach((j) =>
            new CountUp(j, ...timing, options).start(),
        );
    });
}

function init() {
    initCount();
}

export default init;
